import { ReactNode } from 'react';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ModalOwnProps } from '../../../../app/shared/components/modal/model';

export interface ModalNotification {
    title: string;
    message: string | ReactNode;
    showHide?: boolean;
    type?: Exclude<ModalOwnProps['type'], 'basic'>;
    onOk?: () => Promise<void> | void;
    okButtonTitle?: string;
    onCancel?: () => Promise<void> | void;
    cancelButtonTitle?: string;
    closable?: boolean;
}

export interface ModalNotificationsState {
    notifications: ModalNotification[];
}

const initialState: ModalNotificationsState = {
    notifications: [],
};


export const modalNotificationsSlice = createSlice({
    name: '@@modalNotifications',
    initialState,
    reducers: {
        push(state, action: PayloadAction<ModalNotification>) {
            state.notifications = [
                ...state.notifications,
                { ...action.payload },
            ];
        },
        pop(state) {
            state.notifications = state.notifications.slice(0, -1);
        },
        clear(state) {
            state.notifications = [];
        }
    }
});
